export class PredicateEvaluator {
    private static readonly _operators = ["==", "<", ">", ">=", "<=", "!="];

    public static field(expr: string): string {
        let operatorIndex = -1;
        for (const operator of this._operators) {
            let offset = expr.indexOf(operator);
            if (offset >= 0) {
                operatorIndex = offset;
                break;
            }
        }

        if (operatorIndex < 0) {
            throw new Error("Unsupported expression");
        }

        return expr.substr(0, operatorIndex).trim();
    }

    public static test(field: string, value: any, expr: string): boolean {
        const evalExpr = expr.replace(field, this.prepareValue(value));
        const result = eval(evalExpr);
        if (!(typeof(result) === "boolean")) {
            throw new Error("Illegal return type");
        }

        return result;
    }

    private static prepareValue(value: any): any {
        if (typeof(value) === "string") {
            return `'${value}'`;
        }

        return value;
    }

    public static testPossibleWildcardWithRegexp(str:string, wildcard:string):boolean
    {
        // "."  => Find a single character, except newline or line terminator
        // ".*" => Matches any string that contains zero or more characters
        // "\w" => Matches any single character (alphabetical or numeric)
        // "^"  => Matches any string with the following at the beginning of it
        // "$"  => Matches any string with that in front at the end of it
        let rule;
        if( wildcard.search(/~\*/g) != -1 || wildcard.search(/~\?/g) != -1 )
        {
            rule = '^' + wildcard.replace(/~\*/g, '\\*')
                .replace(/~\?/g, '\\?') + '$';
        }
        else
        {
            rule = '^' + wildcard.replace(/[\*]/g, '.*')
                .replace(/[\?]/g, '\\w') + '$';
        }

        //Create a regular expression object for matching string
        var regex = new RegExp(rule, 'i');

        //Returns true if it finds a match, otherwise it returns false
        return regex.test(str);
    }
}
